import { render } from "./AuswahlKatalogCheckboxReadonly.pug?vue&type=template&id=80c9a9aa&lang=pug"
import script from "./AuswahlKatalogCheckboxReadonly.js?vue&type=script&lang=js"
export * from "./AuswahlKatalogCheckboxReadonly.js?vue&type=script&lang=js"

import "./AuswahlKatalogCheckboxReadonly.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__